const NETWORK_ROUTES = {
  path: '/network',
  component: () => import('@/pages/Network/NetworkPagesContainer.vue'),
  children: [
    {
      path: '',
      name: 'network.index',
      component: () => import('@/pages/Network/NetworkPage.vue'),
    },
    {
      path: 'create',
      name: 'network.create',
      component: () => import('@/pages/Network/NetworkFormPage.vue'),
    },
    {
      path: ':id/edit',
      name: 'network.edit',
      component: () => import('@/pages/Network/NetworkFormPage.vue'),
    },
  ],
};

export default NETWORK_ROUTES;
